import { render, staticRenderFns } from "./SyntenyViewer.vue?vue&type=template&id=7ab2b26c&scoped=true"
import script from "./SyntenyViewer.vue?vue&type=script&lang=js"
export * from "./SyntenyViewer.vue?vue&type=script&lang=js"
import style0 from "./SyntenyViewer.vue?vue&type=style&index=0&id=7ab2b26c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab2b26c",
  null
  
)

export default component.exports